module.exports = __webpack_public_path__ + "media/ringtone.93015af1.wav";